import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { Illustration, LinkButton, Navigation } from '~/components';
import { useMediaQuery } from '~/hooks/useMediaQuery';
import { routes } from '~/providers/RouterProvider/router.routes';
import { breakpoints } from '~/styles/media.css';

import { invitationCtaButtonStyle, invitationCtaIllustrationStyle, invitationCtaWrapperStyle, navigationDesktopStyle } from './Layout.css';
import { useNavigationMenuItems } from './Navigation.hooks';

export const NavigationDesktop = () => {
  const navigationMenuItems = useNavigationMenuItems();

  const { t } = useTranslation(['common']);

  const { pathname } = useLocation();

  const isMobile = useMediaQuery(breakpoints.small);

  const invoicingItems = navigationMenuItems.filter((item) => item.group === 'invoicing');
  const communityItems = navigationMenuItems.filter((item) => item.group === 'community');

  if (isMobile) return null;

  return (
    <Navigation.Root className={navigationDesktopStyle} render={<nav aria-label={t('common:navigation.main')} />}>
      <Navigation.Logo to={routes.dashboard} />

      <Navigation.Body>
        <Navigation.Title>{t('common:sidebar.groupInvoicing')}</Navigation.Title>

        {invoicingItems.map((item) => (
          <Navigation.Link
            active={pathname === item.to || !!item.subRoutes?.includes(pathname)}
            data-pf-id={item.productFruitsId}
            icon={item.icon}
            key={item.label}
            to={item.to}
          >
            {item.label}
          </Navigation.Link>
        ))}

        <Navigation.Title>{t('common:sidebar.groupSocial')}</Navigation.Title>

        {communityItems.map((item) => (
          <Navigation.Link
            active={pathname === item.to || !!item.subRoutes?.includes(pathname)}
            data-pf-id={item.productFruitsId}
            icon={item.icon}
            key={item.label}
            to={item.to}
          >
            {item.label}
          </Navigation.Link>
        ))}
      </Navigation.Body>

      <Navigation.Footer>
        <Navigation.ExpandedOnly>
          <div className={invitationCtaWrapperStyle}>
            <Illustration className={invitationCtaIllustrationStyle} name="HandsHeart" strokeWidth={0.8} />

            <LinkButton className={invitationCtaButtonStyle} to={routes.invitations}>
              {t('common:sidebar.invite')}
            </LinkButton>
          </div>
        </Navigation.ExpandedOnly>

        <Navigation.ExternalLink href="https://knowledge.creativeshelter.be/" icon="Help">
          {t('common:sidebar.help')}
        </Navigation.ExternalLink>

        <Navigation.Collapse />
      </Navigation.Footer>
    </Navigation.Root>
  );
};
